import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M14.865 4.764a.7.7 0 0 1 0 .99L5.738 14.88a.7.7 0 0 1-.99-.99l9.127-9.127a.7.7 0 0 1 .99 0ZM9.431 2.821a.7.7 0 0 1 .604.197l1.644 1.644a.7.7 0 1 1-.99.99L9.297 4.26l-4.35.687-.687 4.35 1.392 1.392a.7.7 0 1 1-.99.99l-1.644-1.644a.7.7 0 0 1-.197-.604l.822-5.205a.7.7 0 0 1 .583-.583l5.205-.822Zm4.546 5.129a.7.7 0 0 1 .99 0l1.644 1.643a.7.7 0 0 1 0 .99l-6.028 6.028a.7.7 0 0 1-.99 0L7.95 14.967a.7.7 0 1 1 .99-.99l1.148 1.15 5.038-5.039-1.149-1.149a.7.7 0 0 1 0-.99Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M7.537 6.777a.76.76 0 1 1-1.519 0 .76.76 0 0 1 1.519 0Z" />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
